import {FullDate as ApiFullDate} from 'gabi-api-ts/v2/common/date/date';
import {SignalType} from 'gabi-api-ts/v2/common/signals/signals';
import styled from 'styled-components';
import { $enum } from 'ts-enum-util';

import { TableSortable } from '@/components/table/table-sortable';
import { TableSortableColumn } from '@/components/table/table-sortable-types';
import {
    formatApiDateShortUniversal, formatApiTimeUniversal,
} from '@/util/apidate-util';
import {getSignalTypeLabel, getSignalTypeUnit} from '@/util/signal-type-util';

export type BiometricHistorySpotData = {
    fullDate: ApiFullDate;
    seconds: number;
    values: Array<{
        signalType: SignalType;
        value: number;
    }>;
}

type HealthReportSpotSignalsTableProps = {
    data: BiometricHistorySpotData[];
};
//----------------------------------------------------------------------------------------------------------------------

function tableSortableHeaderColumn(signalType: SignalType) {
    return {
        id: $enum(SignalType).getKeyOrDefault(signalType, ''),
        label: getSignalTypeLabel(signalType),
        className: 'signalTableHeader',
        sortable: false,
    };
}

function HealthReportSpotSignalsTable({data}: HealthReportSpotSignalsTableProps) {
    // Can't be set outside the function, because of the translations
    const tableSortableHeaderColumns: TableSortableColumn<BiometricHistorySpotData>[] = [
        {
            id: 'time',
            label: 'Time',
            sortable: true,
            compareFn: (a, b) => {
                return a.seconds - b.seconds;
            },
        },
        tableSortableHeaderColumn(SignalType.Signal_PR),
        tableSortableHeaderColumn(SignalType.Signal_SPO2),
        tableSortableHeaderColumn(SignalType.Signal_BP_SYS),
        tableSortableHeaderColumn(SignalType.Signal_BP_DIA),
        tableSortableHeaderColumn(SignalType.NEWS2),
    ];
    return (
        <TableSortable
            data={data}
            keyFn={item => `${item.seconds}`}
            columns={tableSortableHeaderColumns}
            defaultSorting={{id: 'timestampNumber', sortByOrder: 'asc'}}
            TableBodyRowComponent={(props: HealthReportSpotSignalsTableRowProps) => (<HealthReportSpotSignalsTableRow {...props} />)}
        />
    );
}
//----------------------------------------------------------------------------------------------------------------------

type HealthReportSpotSignalsTableRowProps = {
    data: BiometricHistorySpotData;
};

function HealthReportSpotSignalsTableRow({data}: HealthReportSpotSignalsTableRowProps) {
    return (
        <StyledWrapper>
            <td className="">
                {formatApiDateShortUniversal(data.fullDate.date!)}
                {' '}
                {formatApiTimeUniversal(data.fullDate.time!)}
            </td>
            <DataCell data={data} signalType={SignalType.Signal_PR} />
            <DataCell data={data} signalType={SignalType.Signal_SPO2} />
            <DataCell data={data} signalType={SignalType.Signal_BP_SYS} />
            <DataCell data={data} signalType={SignalType.Signal_BP_DIA} />
            <DataCell data={data} signalType={SignalType.NEWS2} />
        </StyledWrapper>
    );
}

type DataCellProps = {
    data: BiometricHistorySpotData;
    signalType: SignalType;
};
function DataCell({data, signalType}: DataCellProps) {
    const value = data.values.find(v => v.signalType === signalType);
    return (
        <td className="">
            {!value ? null : value.value}
            {getSignalTypeUnit(signalType)}
            {/*{data.values.length > 1 && (*/}
            {/*    <span className="signal-type-unit-label">*/}
            {/*        {getSignalTypeUnit(signalType)}*/}
            {/*    </span>*/}
            {/*)}*/}
            {/*{formatApiDateShortUniversal(data.timestamp.date)}*/}
            {/*{' '}*/}
            {/*{formatApiTimeUniversal(data.timestamp.time)}*/}
        </td>
    );
}

//language=SCSS
const StyledWrapper = styled.tr`
& {
    th {
        font-size: 12px;
    }
    
    .linkCell {
        padding: 5px;
    }
    
    .eventsCell {
        width: 30%;
        min-width: 110px;
        max-width: 140px;
        border-left: 4px solid transparent;
        strong {
            font-size: 16px;
        }
    }
}
`;

export {HealthReportSpotSignalsTable};
